import { assert } from '@ember/debug';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';
import WrButton from '../../button.gts';
import type { InputControlSignature } from './input.gts';

interface FileInputSig {
  Element: HTMLInputElement;
  Args: Pick<InputControlSignature['Args'], 'onChange' | 'value'>;
}

export default class FileInput extends Component<FileInputSig> {
  @tracked selectedFile?: File;
  declare input: HTMLInputElement;

  init = modifier((el: HTMLInputElement) => {
    this.input = el;
  });

  clickInput = () => {
    this.input.click();
  };

  handleChange = (e: Event | InputEvent): void => {
    assert('Expected HTMLInputElement', e.target instanceof HTMLInputElement);
    this.selectedFile = e.target.files?.[0];

    // TODO
    this.args.onChange?.(e.target.value, e);
  };

  removeFile = (e: Event | InputEvent) => {
    this.input.value = '';
    this.selectedFile = undefined;

    // TODO
    this.args.onChange?.(this.input.value, e);
  };

  <template>
    <div class='flex items-center gap-2'>
      <WrButton @variant='primary' type='button' {{on 'click' this.clickInput}}>
        {{! This text is taken from Chrome 144 MacOS }}
        Choisir un fichier
      </WrButton>

      <WrButton
        @variant='link'
        {{on 'click' this.clickInput}}
        class='hover:no-underline'
      >
        {{#if this.selectedFile}}
          {{this.selectedFile.name}}
        {{else}}
          {{! This text is taken from Chrome 144 MacOS }}
          Aucun fichier choisi
        {{/if}}
      </WrButton>

      {{#if this.selectedFile}}
        <WrButton
          @icon='Trash'
          @variant='outlined-mini'
          {{on 'click' this.removeFile}}
        />
      {{/if}}
    </div>

    <input
      class='hidden'
      value={{@value}}
      {{on 'change' this.handleChange}}
      {{this.init}}
      ...attributes
      type='file'
    />
  </template>
}
